import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Impact } from './components/Impact';
import { GiftForm } from './components/GiftForm';
import { Testimonials } from './components/Testimonials';
import { DigitalOptions } from './components/DigitalOptions';
import { Closing } from './components/Closing';
import { Footer } from './components/Footer';
export function App() {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <Impact data-id="element-4" />
        <GiftForm data-id="element-5" />
        <Testimonials data-id="element-6" />
        <DigitalOptions data-id="element-7" />
        <Closing data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}